import { initializeFeature } from 'owa-feature-flags';
import { initialize as initializeDefaultSettingsExperiment } from 'owa-mail-defaultsettings';
import { initializeFocusedInboxConfig } from 'owa-mail-focused-inbox-config';
import { loadFolderForest } from 'owa-mail-folder-forest-actions';
import { reloadInboxPostBoot } from 'owa-mail-list-actions';
import { initializeTablesInCache } from 'owa-mail-list-actions/lib/actions/helpers/tableCache/updateTablesInCache';
import { setShowFolderPane, setFolderPaneWidth } from 'owa-mail-module-actions';
import { initializeShowReadingPane } from 'owa-mail-module-orchestrator';
import { getMoveToMruList } from 'owa-mail-move-mru';
import FolderPaneExpansionSource from 'owa-mail-store/lib/store/schema/FolderPaneExpansionSource';
import { lazyInitializeUpNext } from 'owa-upnext';
import { lazyInitializeUpNextV2 } from 'owa-upnext-v2';
import { action } from 'satcheljs/lib/legacy';
import { initializeInboxPlus } from 'owa-mail-inbox-plus-actions';
import { isFeatureEnabled } from 'owa-feature-flags';

export default action('initializeMailModuleState')(function initializeMailModuleState(): void {
    initializeDefaultSettingsExperiment();
    initializeFocusedInboxConfig();
    if (isFeatureEnabled('tri-inbox-plus-v1')) {
        initializeInboxPlus();
    }
    initializeTablesInCache();
    loadFolderForest();
    initializeShowReadingPane();

    // Experiment to see whether always showing the task button in module switcher will lead to more clicks
    if (isFeatureEnabled('tri-leftNavWidthFull') && isFeatureEnabled('fwk-fluentCommandBar')) {
        setFolderPaneWidth(284, FolderPaneExpansionSource.Init);
    }

    setShowFolderPane(FolderPaneExpansionSource.Init);
    getMoveToMruList();
    reloadInboxPostBoot();

    initializeFeature('tri-upNext', async () => {
        const initializeUpNext = await lazyInitializeUpNext.import();
        initializeUpNext();
    });

    initializeFeature('tri-upNextV2', async () => {
        const initializeUpNextV2 = await lazyInitializeUpNextV2.import();
        initializeUpNextV2();
    });
});
